import axios from 'axios';
import baseConfig from '../config/index.js';
import Vue from 'vue';
import store from '../store/index.js';

// 添加请求拦截器
axios.interceptors.request.use(config => {
  if (!config.isCustomUrl) { // 是否是自定义域名 否则取默认配置项
    config.url = baseConfig.apiPath + config.url;
  }
  // 在发送请求之前做些什么
  config.headers['access-token'] = store.state.user.userInfo.token || '';
  if (config.isNoToken) {
    delete config.headers['access-token'];
  }
  return config;
}, error => {
  return Promise.reject(error);
});

// 添加响应拦截器
axios.interceptors.response.use(response => {
  let code = response.data.code,
    config = response.config;
  if (code === '004') {
    window.localStorage.removeItem('token');
    axios.defaults.headers.common['access-token'] = '';
    window.location.href = '#/login';
    store.dispatch('user/removeUser');
  }
  // 返回所有的数据 包括 msg code data...
  if (config._isAll === true) {
    return response.data || {};
  }
  // 对响应数据做点什么
  if (code === '000') {
    // 只返回 data
    return response.data.data || {};
  } else {
    return Promise.reject(response.data);
  }
  // return response;
}, error => {
  // 对响应错误做点什么
  console.error(error);
  return Promise.reject(error);
});

const Http = (params = {}) => {
  const _ajax = arg => {
    return axios(Object.assign(params, arg));
  };
  return {
    // 返回一个 post请求 promise
    post: () => _ajax({method: 'post'}),
    // 返回一个 get请求 promise
    get: () => _ajax({method: 'get'}),
    // 返回一个 get请求 promise
    put: () => _ajax({method: 'put'}),
    // 返回一个 get请求 promise
    delete: () => _ajax({method: 'delete'})
  };
};

Vue.prototype.$http = axios;
Vue.prototype.$config = baseConfig;

export const $http = Http;



// WEBPACK FOOTER //
// ./src/utils/http.js